import { Flex, Text } from '@enechain/ecloud-designsystem'

type Props = {
  label: string
  children: React.ReactNode
}

/** 詳細の見出しの 1 項目 (ラベルの下に値)。 自社の通告値と他社の通告値の詳細で共通。 */
export const InfoItem = ({ label, children }: Props): React.ReactElement => (
  <Flex flexDirection="column" gap={0.5}>
    <Text textStyle="caption" color="Text.midEmphasis">
      {label}
    </Text>
    {/* 値には AuditCell (div) も入るので p にしない */}
    <Text as="div" textStyle="label">
      {children}
    </Text>
  </Flex>
)
